/**
* Two Image CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Two Image CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'two-image-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const mm = gsap.matchMedia();

      mm.add( {
        isDesktop: '(min-width: 768px)',
        isTablet: '(min-width: 480px) and (max-width: 767px)',
        isMobile: '(max-width: 479px)',
        reduceMotion: '(prefers-reduced-motion: reduce)',
      }, ( context ) => {
        const {isDesktop, isTablet, isMobile, reduceMotion} = context.conditions;

        // Set different parallax values based on screen size
        let fromYPercent = -3;
        let toYPercent = 3;

        if ( isTablet ) {
          fromYPercent = -1;
          toYPercent = 1;
        }

        if ( isMobile ) {
          fromYPercent = 0;
          toYPercent = 0;
        }

        // Don't apply parallax if reduced motion is preferred
        if ( reduceMotion ) {
          fromYPercent = 0;
          toYPercent = 0;
        }

        const timeline = gsap.timeline( {
          scrollTrigger: {
            trigger: '.two-image-cta',
            start: '50% bottom',
            end: 'top top',
            scrub: 1,
          },
        } );

        if ( $( '.parallax' ).length ) {
          timeline.addLabel( 'start' )
              .from( '.parallax', {yPercent: fromYPercent} )
              .to( '.parallax', {yPercent: toYPercent} );
          timeline.addLabel( 'end' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'two-image-cta', COMPONENT );
} )( app );
